<template>
  <div>
    <div class="row border-bottom">
      <div class="col-md-12 col text-center">
        <p class="global-activity-title pb-10 m-0" v-translate:settings_key="lang">Settings</p>
      </div>
    </div>

    <div id="settings" class="setting-list">
      <ul class="list-group">
        <template v-if="participant.verificationMethod === 'phone' && contactPhoneEnabled && !isBothPhoneAreSame">
          <div class="settings_main_title" v-translate:label_sms_notifications="lang">SMS Notifications</div>
          <li class="list-group-item verfy_phone" :class="{ 'no-bottom-border': !contactPhoneEnabled || isBothPhoneAreSame }">
            <div class="d-flex justify-content-between">
              <div class="settings_title">
                <label v-translate:label_verification_phone="lang">Verification Phone</label>
                <p>{{ participant.mobile | national(participant.participantMeta.countryCode) | trim0 }}</p>
              </div>
              <div>
                <div class="switch-option d-flex align-items-center">
                  <label class="switch mb-0" :class="{ 'switch-on': verificationPhoneSmsStatus }">
                    <span class="setting-btn-text off">Off</span>
                    <input type="checkbox" @change="onVerificationPhoneSmsToggle" v-model="verificationPhoneSmsStatus" />
                    <div class="slider round"></div>
                    <span class="setting-btn-text on" v-translate:toggle_on="lang">On</span>
                  </label>
                </div>
              </div>
            </div>
          </li>
          <li class="list-group-item phone">
            <div class="d-flex justify-content-between align-items-center">
              <div class="settings_title">
                <label v-translate:label_phone="lang">Phone</label>
                <p>{{ (participant.participantMeta.countryCode + participant.participantMeta.phoneNumber) | national(participant.participantMeta.countryCode) | trim0 }}</p>
              </div>
              <div>
                <div class="switch-option d-flex align-items-center">
                  <label class="switch mb-0" :class="{ 'switch-on': smsToggleNotification }">
                    <span class="setting-btn-text off">Off</span>
                    <input type="checkbox" @change="updateSmsToggleNotification($event)" v-model="smsToggleNotification" />
                    <div class="slider round"></div>
                    <span class="setting-btn-text on" v-translate:toggle_on="lang">On</span>
                  </label>
                </div>
              </div>
            </div>
          </li>
        </template>
        <li class="list-group-item" v-else>
          <div class="d-flex justify-content-between">
            <div class="settings_title" v-translate:label_sms_notifications="lang">SMS Notifications</div>
            <div>
              <div v-if="!participant.verificationMethod || participant.verificationMethod === 'email'" class="switch-option d-flex align-items-center">
                <label v-if="isSmsNotificationLoaded" class="switch mb-0" :class="{ 'switch-on': smsToggleNotification }">
                  <span class="setting-btn-text off">Off</span>
                  <input type="checkbox" @change="updateSmsToggleNotification($event)" v-model="smsToggleNotification" />
                  <div class="slider round"></div>
                  <span class="setting-btn-text on" v-translate:toggle_on="lang">On</span>
                </label>
              </div>
              <div v-else class="switch-option d-flex align-items-center">
                <label class="switch mb-0" :class="{ 'switch-on': verificationPhoneSmsStatus }">
                  <span class="setting-btn-text off">Off</span>
                  <input type="checkbox" @change="toggleBothPhone($event)" v-model="verificationPhoneSmsStatus" />
                  <div class="slider round"></div>
                  <span class="setting-btn-text on" v-translate:toggle_on="lang">On</span>
                </label>
              </div>
            </div>
          </div>
        </li>
        <li class="list-group-item border-top" @click="navigateTab('change-password')">
          <div class="d-flex justify-content-between">
            <div class="settings_title" v-translate:change_password="lang">Change Password</div>
            <div>
              <!-- <i class="fa fa-chevron-right" aria-hidden="true"></i> -->
              <img src="static/img/participant-portal/forward_arrow.svg" alt="chevron-right" />
            </div>
          </div>
        </li>
        <li class="list-group-item" @click="navigateTab('language')">
          <div class="d-flex justify-content-between">
            <div class="settings_title" v-translate:profile_language_title="lang">Language</div>
            <div>
              <!-- <i class="fa fa-chevron-right" aria-hidden="true"></i> -->
              <img src="static/img/participant-portal/forward_arrow.svg" alt="chevron-right" />
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { Widget, Bitrise } from "@/components/services/participant-service";
export default {
  name: "settings",
  data() {
    return {
      smsToggleNotification: false,
      pid: "",
      globalElement: null,
      widget: new Widget(),
      bitrise: new Bitrise(),
      verificationPhoneSmsStatus: false,
      configFields: [],
      phoneField: null,
      contactPhoneEnabled: true,
      isSmsNotificationLoaded: false
    };
  },
  mounted() {
    this.getFormConfig();
    this.getSmsNotification();
  },
  computed: {
    ...mapGetters(["participant", "token"]),
    lang() {
      let selectedLanguage = this.$store.getters.getParticipantsPortalLanguages;
      return selectedLanguage ? selectedLanguage.language_culture : "en";
    },
    isBothPhoneAreSame() {
      let verificationMobile = this.$options.filters.e164(this.participant.mobile, this.participant.mobileCountryCode);
      let contactPhone = this.$options.filters.e164(this.participant.participantMeta.phoneNumber, this.participant.participantMeta.countryCode);
      return verificationMobile === contactPhone;
    },
    isPhoneNumber() {
      // SMS functionality validated by TUR-159308
      return this.participant && this.participant.participantMeta && !!this.participant.participantMeta.phoneNumber;
    }
  },
  methods: {
    ...mapActions(["participantLogout"]),
    logout() {
      this.participantLogout();
    },
    updateParticipant() {
      this.$api.updateParticipantDataFact(this.participant.pid, this.participant).then(response => {});
    },
    navigateTab(tab) {
      this.$router.push({
        name: "participants-portal-profile-" + tab,
        params: {}
      });
    },
    getSmsNotification() {
      this.$api
        .getSmsToggleNotification(this.participant.pid)
        .then(response => {
          this.smsToggleNotification = response.body.optInSMS;
          this.isSmsNotificationLoaded = true;
        })
        .catch(error => {
          this.$toastr.error(error && error.body ? error.body.message : "Error in getting Notification details");
        });
      if (this.participant.verificationMethod == "phone") {
        this.$api
          .getVerificationPhoneSmsToggleNotification(this.participant.pid)
          .then(response => {
            this.verificationPhoneSmsStatus = response.body.verificationPhoneOptInSms;
            this.isSmsNotificationLoaded = true;
          })
          .catch(error => {
            this.$toastr.error(error && error.body ? error.body.message : "Error in getting Toggle Notification details");
          });
      }
    },
    toggleBothPhone(event) {
      const optInSMS = event.target.checked;
      if (!this.isPhoneNumber && optInSMS && this.participant.verificationMethod == "phone") {
        this.verificationPhoneSmsStatus = false;
        this.$toastr.error(this.widget.translate("label_enter_phone_number", "Enter your phone number."));
        return;
      }
      let promises = [
        this.participant.verificationMethod == "phone"
          ? new Promise((res, rej) =>
              this.$api
                .verificationPhoneSmsToggle(this.participant.pid, { verificationPhoneOptInSms: optInSMS })
                .then(res)
                .catch(rej)
            )
          : new Promise((res, rej) =>
              this.$api
                .updateSmsToggleNotification(this.participant.pid, { optInSms: optInSMS })
                .then(res)
                .catch(rej)
            )
      ];
      Promise.all(promises).then(response => {
        let message = this.widget.translate(response[0].body.message && response[0].body.message.includes("unsubscribed") ? "label_sms_unsubscribed" : "label_sms_subscribed", response[0].body.message);
        this.$toastr.success(message);
      });
    },
    updateSmsToggleNotification(event) {
      const optInSMS = event.target.checked;
      if (!this.isPhoneNumber && optInSMS) {
        this.smsToggleNotification = false;
        this.$toastr.error(this.widget.translate("label_enter_phone_number", "Enter your phone number."));
        return;
      }
      this.$api
        .updateSmsToggleNotification(this.participant.pid, {
          optInSms: optInSMS
        })
        .then(response => {
          this.smsToggleNotification = response.body.optInSMS;
          this.$toastr.success(this.smsToggleNotification ? this.widget.translate("label_sms_subscribed", "You have successfully subscribed to receive text messages.") : this.widget.translate("label_sms_unsubscribed", "You have been unsubscribed from receiving text messages."));
        });
    },
    onVerificationPhoneSmsToggle() {
      this.$api
        .verificationPhoneSmsToggle(this.participant.pid, {
          verificationPhoneOptInSms: this.verificationPhoneSmsStatus
        })
        .then(response => {
          this.$toastr.success(this.verificationPhoneSmsStatus ? this.widget.translate("label_sms_subscribed", "You have successfully subscribed to receive text messages.") : this.widget.translate("label_sms_unsubscribed", "You have been unsubscribed from receiving text messages."));
        });
    },
    getFormConfig() {
      let registrationDataObj = this.bitrise.getJsonData("study_participantregistrationconfiguration");
      if (registrationDataObj) {
        registrationDataObj
          .then(response => {
            let configFields = response.participantRegistrationConfigDetails;
            this.phoneField = configFields.find(o => o.key === "phoneNumber");
            this.contactPhoneEnabled = this.phoneField ? this.phoneField.isVisible : false;
          })
          .catch(e => {
            let message = this.widget.translate(e.message, "Data sync failed, please try again after some time.");
            if (message) {
              this.$toastr.error(message);
            }
          });
      }
    }
  }
};
</script>

<style scoped lang="scss">
.email-id {
  font-size: 18px;
  padding: 0% 10% 2%;
}
.setting-list {
  width: auto;
  height: auto;
  border: solid 1px #d8e3e7;
  border-top: hidden;
  background-color: #ffffff;
}
.setting-list .list-group-item:first-child {
  border-top: solid 0px #d8e3e7;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.setting-list .list-group-item {
  position: relative;
  display: block;
  padding: 20px 26px;
  margin-bottom: -1px;
  background-color: transparent;
  border: solid 0px #d8e3e7;
  font-family: Roboto;
  font-size: 18px;
  color: #9b9b9b;
  border-bottom: solid 1px #d8e3e7;
  cursor: pointer;
}
.setting-list .list-group-item a {
  font-size: 18px;
  color: #9b9b9b;
}
.setting-list .list-group-item a:hover {
  font-size: 18px;
  color: var(--secondary);
  text-decoration: none;
}
.setting-list .list-group-item:hover .settings_title {
  cursor: pointer;
  color: var(--secondary);
}
.setting-list .list-group-item.sms_notification:hover .settings_title {
  cursor: pointer;
  color: #9b9b9b;
}
.switch-button {
  font-size: 14px;
}

.setting-list .settings_title label {
  font-size: 14px;
  color: #666669;
  margin: 0;
  font-weight: 600;
  letter-spacing: -0.41px;
}
.setting-list .settings_title p {
  font-size: 12px;
  color: #949496;
  opacity: 0.8;
  letter-spacing: -0.41px;
  margin: 0;
}

.list-group .list-group-item .phone-div {
  border-bottom: solid 1px #d8e3e7;
  padding: 5px 0 10px;
}
.list-group .list-group-item .phone-div:last-child {
  border-bottom: 0;
  padding: 0;
}
.setting-list .list-group-item.verfy_phone {
  padding: 10px 0;
  margin: 0 26px;
  border-top: 0;
}
.no-bottom-border {
  border-bottom: 0 !important;
}
.setting-list .list-group-item.phone {
  border-bottom: solid 1px #d8e3e7;
  padding: 10px 26px;
  border-bottom: 0;
}

.switch {
  position: relative;
  display: inline-block;
  width: 56px;
  height: 24px;
  margin-right: 5px;
}
.switch-option {
  position: relative;
}

/* Hide default HTML checkbox */
.switch input {
  display: none;
}
.setting-btn-text.off {
  right: 10px;
}
.setting-btn-text.on {
  left: 10px;
  display: none;
}
.switch-on .setting-btn-text.on {
  display: block;
}
.switch-on .setting-btn-text.off {
  display: none;
}
.setting-btn-text {
  color: #fff;
  font-size: 14px;
  z-index: 1;
  position: absolute;
  text-transform: capitalize;
  bottom: 2px;
  cursor: pointer;
}
/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 2px solid #ccc;
  background-color: #ccc;
}
.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 2px;
  bottom: 2px;
  background-color: #fff;
}
input:checked + .slider {
  border: 2px solid #48bf7a;
  background-color: #48bf7a;
}

input:checked + .slider:before {
  /*content: '✓';*/
  position: absolute;
  color: #2ecc71;
  text-align: center;
  font-size: 20px;
  -webkit-transform: translateX(30px);
  -ms-transform: translateX(30px);
  transform: translateX(30px);
}
/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
li.list-group-item .phone-div:hover {
  font-size: 18px;
  color: #9b9b9b;
  text-decoration: none;
}
.settings_main_title {
  padding: 20px 26px 10px;
  font-family: Roboto;
  font-size: 18px;
}
</style>
